import {useIntl} from 'react-intl';
import {useEffect, useState} from 'react';
import Modal from 'Components/Modal';
import QuickViewCard from "Components/ProgramFinder/QuickViewCard/saf";
import cleanFieldValue from 'utils/cleanFieldValue';

const CardItem = ({data}) => {
  const [isOpen, setIsOpen] = useState(false);

  const intl = useIntl();
  const emptyLabel = intl.formatMessage({id: 'ProgramCard.Label.None'});
  const {
    nid,
    title,
    displayed_destination,
    field_prgm_type,
    field_prgm_rank_group,
    program_card_image,
    university_logo,
    field_short_title,
    prgm_gpa_req,
    field_prgm_lang_instruct,
    field_prgm_lang_pre_lvl,
    field_prgm_status
  } = data || {};

  const url = `/node/${nid}`;

  const [breakpoint, setBreakpoint] = useState(window.innerWidth);

  const onResize = () => {
    setBreakpoint(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    }
  }, []);

  if (!data) {
    return null;
  }

  const programType = () => {
    const classes = field_prgm_type.toLowerCase() === 'standard' ? 'link--tag link--tag-pink mb-10 inline-flex'
      : 'link--tag inline-flex mb-10';
    const text = field_prgm_type.toLowerCase() === 'standard' ? 'Study Abroad'
      : field_prgm_type.toLowerCase() === 'internship' ? 'Full-time Internship' : field_prgm_type;

    return (
      <span className={classes}>{text}</span>
    )
  };

  const media = () => {
    return (
      <div className="program-half__image-container relative">
        {
          field_prgm_type &&
          <div
            class="program--type absolute top-20 left-20 z-10 flex items-start flex-wrap gap-x-10">
            {field_prgm_status === 0 ?
              <span class="link--tag link--tag-suspended inline-flex mb-10">
                 {intl.formatMessage({id: 'ProgramCard.Status.Label'})}
              </span> : ''
            }
            {programType()}
            {
              field_prgm_rank_group &&
              <span class="program--rank link--tag inline-flex mb-10">
                {field_prgm_rank_group}
              </span>
            }
          </div>
        }
        <div dangerouslySetInnerHTML={{__html: program_card_image}}></div>
      </div>
    );
  };

  const universityLogo = () => {
     let classNames =  "program--university-logo hidden";
    // Turn off University Logo per Legal Dept. 08.29.2024
    // let classNames =  "program--university-logo hidden";
    // if (!university_logo.includes('<img ')) {
    //   classNames = "program--university-logo hidden no-logo"
    // }
    // return (
    //   <div className={classNames} >
    //     <div dangerouslySetInnerHTML={{__html: university_logo}}></div>
    //   </div>
    // );
    return (
      <div className={classNames} >
        <div></div>
      </div>
    );
  };

  const heading = () => {
    return (
      <h4 className="program--title mb-16">
        <a href={url}
           className="text-blue-default no-underline link--custom-underline">
          {field_short_title ? field_short_title : title}
        </a>
      </h4>
    );
  };

  const mobileCard = () => {

    return (
      <article
        className="program program-card-mobile overflow-hidden lg:hidden swiper-slide flex flex-col shadow-default js-dL-programcardHover">
        {media()}
        <div
          className="program-card-mobile__details-container py-20 px-22 flex flex-col bg-white h-auto flex-grow">
          {
            displayed_destination &&
            <div
              className="program--location mb-4 font-bold text-12 text-teal-default uppercase">
              {typeof displayed_destination === 'object' ? displayed_destination.join(' | ') : displayed_destination}
            </div>
          }

          {heading()}

          <div class="program-card__details-footer">
            <a className="button button--small justify-center w-full mt-24"
               href={url}>
              {intl.formatMessage({id: 'ProgramCard.CTA.Label'})}
            </a>
          </div>
        </div>
      </article>
    );
  };
  
  const desktopCards = () => {
    let hasUniversityLogo = university_logo.includes('<img ') ? true : false;
    return (
      <article
        className="node node--type-program program program-card overflow-hidden js-modal-parent-target hidden lg:block shadow-default js-dL-programcardHover">
        {media()}

        <div
          className={`program-card__details-container py-20 px-22 flex-col flex ${hasUniversityLogo ? 'has-university-logo' : ''}`}>
          {universityLogo()}

          {
            displayed_destination &&
            <div
              className="program--location mb-4 font-bold text-12 text-teal-default uppercase">
              {typeof displayed_destination === 'object' ? displayed_destination.join(' | ') : displayed_destination}
            </div>
          }

          {heading()}

          <div class="program-card__hover">
            <div class="program--gpa mb-10">
              <label className="font-bold inline-block">
                {intl.formatMessage({id: 'ProgramCard.GPARequirements.Label'})}:&nbsp;
              </label>
              {prgm_gpa_req >= 0 ? prgm_gpa_req.toFixed(2) : emptyLabel}
            </div>

            <div class="program--lang-instruc mb-10">
              <label className="font-bold inline-block">
                {intl.formatMessage({id: 'ProgramCard.LanguageOfInstruction.Label'})}:&nbsp;
              </label>
              {cleanFieldValue(field_prgm_lang_instruct, emptyLabel)}
            </div>

            {field_prgm_lang_pre_lvl &&
              <div class="program--lang-req mb-10">
                <label className="font-bold inline-block">
                  {intl.formatMessage({id: 'ProgramQuickView.languagePrerequisiteLevel.Label'})}:&nbsp;
                </label>
                {cleanFieldValue(field_prgm_lang_pre_lvl, emptyLabel)}
              </div>
            }

          </div>

          <div class="program-card__details-footer">
            <button
              className="button button--small justify-center w-full program-card__hover mt-24 js-open-modal js-dL-programCardQuickView"
              onClick={() => setIsOpen(true)}>
              {intl.formatMessage({id: 'ProgramCard.CTA.Label'})}
            </button>

            {
              isOpen &&
              <Modal setIsOpen={setIsOpen}
                     modalContent={<QuickViewCard data={data} url={url}/>}
              />
            }
          </div>
        </div>
      </article>
    )
  };

  const content = breakpoint > 1023 ? desktopCards() : mobileCard();

  return (
    <>
      {content}
    </>
  )
};

export default CardItem;
